import comp from "./StandardRubric";
export default comp;
